let PARTICLE_BASE_URL = "/api/v2/particle/";

var ParticleApi = {
  async callFunction(coreId, name, arg, productType) {
    let url;
    url =
      PARTICLE_BASE_URL + "devices/" + productType + "/" + coreId + "/" + name;
    const payload = { arg: arg };
    const response = await this.postNetworkItem(url, payload);
    return response;
  },

  getVariable(productId, coreId, variable) {
    const url =
      PARTICLE_BASE_URL +
      "products/" +
      productId +
      "/devices/" +
      coreId +
      "/" +
      variable;
    const response = this.getNetworkItem(url, "variable", variable);
    return response;
  },

  getSimDetails(productId, iccid) {
    const url = PARTICLE_BASE_URL + "products/" + productId + "/sims/" + iccid;
    const response = this.getNetworkItem(url, "sims", iccid);
    return response;
  },

  getSimUsage(productId, iccid) {
    const url =
      PARTICLE_BASE_URL +
      "products/" +
      productId +
      "/sims/" +
      iccid +
      "/data_usage";
    const response = this.getNetworkItem(url, "simsusage", iccid);
    return response;
  },

  getDeviceDetails(productId, coreId) {
    const url =
      PARTICLE_BASE_URL + "products/" + productId + "/devices/" + coreId;
    const response = this.getNetworkItem(url, "devices", coreId);
    return response;
  },

  async getNetworkItem(url, asset_name, key) {
    try {
      let response = await fetch(url);

      if (response.ok) {
        response = response.json();
      } else {
        throw new Error(response.statusText);
      }
      return response;
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " +
          asset_name +
          " [" +
          key +
          "] from the network",
        error.message
      );
      throw error;
    }
  },
  async postNetworkItem(url, payload) {
    try {
      let response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        response = response.json();
      } else {
        return response.json();
      }
      return response;
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      return Promise.reject(error);
    }
  },
};

export default ParticleApi;
